import React, { Ref } from 'react';
import mergeRefs from 'react-merge-refs';

import { ZonedDate } from '@eika-infrastruktur/date';
import { DateInput } from '@eika/date-input';

import { FocusableHtmlElement, useFocusRef } from '../../sporsmalsflyt/hooks';
import { DateAsString } from '../../types/generated-types';

import './dato-input.scss';

export const getDateWithCorrectTimezone = (date: ZonedDate): DateAsString =>
    new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())).toString();

interface Props {
    label?: string;
    sublabel?: string;
    id: string;
    onChange: (date?: ZonedDate) => void;
    placeholder?: string;
    date?: ZonedDate;
    minDate?: ZonedDate;
    maxDate?: ZonedDate;
    focusOnMount: boolean;
    error?: string;
    errorRef?: Ref<FocusableHtmlElement>;
}

export const DatoInput = ({
    label,
    sublabel,
    id,
    onChange,
    placeholder,
    date,
    minDate,
    maxDate,
    error,
    focusOnMount = false,
    errorRef,
}: Props) => {
    const ref = useFocusRef<HTMLInputElement>(focusOnMount);

    return (
        <DateInput
            id={id}
            label={label}
            sublabel={sublabel}
            onChange={onChange}
            maxDate={maxDate}
            minDate={minDate}
            date={date}
            ref={mergeRefs([ref, errorRef])}
            placeholder={placeholder}
            error={error}
        />
    );
};
